import { useId } from 'react';

export default function Accordion({ title, meta, children, open = false, className = '', anchorId }) {
  const id = useId();
  return (
    <details id={anchorId} className={`accordion ${className}`} open={open}>
      <summary aria-controls={id}>
        <span><strong>{title}</strong>{meta ? <small>{meta}</small> : null}</span>
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M12 5v14" /></svg>
      </summary>
      <div id={id} className="accordion__body">{children}</div>
    </details>
  );
}
